import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const UserContext = createContext({ user: null, loading: true, refresh: async () => {}, signIn: () => {}, signOut: async () => {} });

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // Skip if returning from OAuth callback — AuthCallback handles it
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const signIn = (returnTo) => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const target = returnTo || window.location.pathname + window.location.search;
        try {
            sessionStorage.setItem("post_login_redirect", target);
        } catch {}
        const redirectUrl = window.location.origin + "/auth/callback";
        // app_name + app_title query params hint the Emergent OAuth screen to display
        // the correct product name ("Aangan Theory") instead of the URL-slug fallback.
        const params = new URLSearchParams({
            redirect: redirectUrl,
            app_name: "Aangan Theory",
            app_title: "Aangan Theory",
            name: "Aangan Theory",
        });
        window.location.href = `https://auth.emergentagent.com/?${params.toString()}`;
    };

    const signOut = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        setUser(null);
    };

    return (
        <UserContext.Provider value={{ user, loading, refresh, signIn, signOut }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}
